import { useParams } from "react-router-dom";
import serviceData from "../../data/service.json";
import images from "../../assets/images/Constant";
import Banner from "../common/Banner";
import { IoChevronForward } from "react-icons/io5";
import { FaCheck } from "react-icons/fa";
import { useState } from "react";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";



const ServiceDetails = () => {
  const { id } = useParams();
  const [activeFAQ, setActiveFAQ] = useState(0);
  const service = serviceData.services.find((s) => s.id === id);

  if (!service) return <div>Service not found</div>;

  return (
    <>
      <Banner
        title={serviceData?.banner1?.title || "Service"}
        currentLabel={serviceData?.banner1?.breadcrumb || "Service"}
      />

      <section className="bg-white py-16">
        <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-3 gap-10">

          {/* LEFT CONTENT */}
          <div className="lg:col-span-2">

            {/* IMAGE */}
            <img
              src={images[service.details.mainImage]}
              alt=""
              className="w-full h-[320px] md:h-[519px] object-cover"
            />

            {/* TITLE */}
            <h2 className="text-2xl md:text-3xl text-dark font-semibold mt-6">
              {service.details.bannerTitle}
            </h2>

            {/* DESCRIPTION */}
            <p className="mt-4 text-light">{service.details.content}</p>
            <p className="mt-4 text-light">{service.details.content1}</p>

            <h2 className="text-2xl md:text-3xl text-dark font-semibold mt-6">
              {service.details.heading}
            </h2>
            <p className="mt-4 text-light">{service.details.description}</p>

            {/* BENEFITS */}
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
              <img
                src={images[service.details.mainImage]}
                alt=""
                className="w-full h-[260px] object-cover"
              />

              <div>
                <h3 className="text-dark text-[24px] font-semibold mb-6">
                  Key Benefits
                </h3>
                <ul className="space-y-3 text-base text-dark">
                  {service.details.benefits.map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <FaCheck className="text-primary mt-1" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <h2 className="text-2xl text-dark md:text-3xl font-semibold mt-8">
              {service.details.heading1}
            </h2>
            <p className="mt-4 text-light">{service.details.description1}</p>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <img
                src={images[service.details.mainImage]}
                alt=""
                className="w-full h-[240px] object-cover"
              />
              <img
                src={images[service.details.mainImage]}
                alt=""
                className="w-full h-[240px] object-cover"
              />
            </div>

            {/* FAQ (integrated like screenshot) */}
            <div className="mt-12 space-y-4">
              {(service?.details?.faq || []).map((faq, index) => (
                <div key={index} className="bg-[#F4F4F4] border border-[#EDEDED]">
                  <button
                    type="button"
                    onClick={() =>
                      setActiveFAQ(activeFAQ === index ? null : index)
                    }
                    className="w-full flex justify-between items-center px-6 py-6 text-left"
                    aria-expanded={activeFAQ === index}
                  >
                    <span
                      className={`text-base md:text-lg font-semibold flex-1 min-w-0 pr-3 ${
                        activeFAQ === index ? "text-primary" : "text-[#0b2c3d]"
                      }`}
                    >
                      {faq.question}
                    </span>

                    <span className="text-primary text-2xl">
                      {activeFAQ === index ? <IoChevronUp /> : <IoChevronDown />}
                    </span>
                  </button>

                  {activeFAQ === index && (
                    <div className="px-6 pb-6 -mt-2">
                      <p className="text-light text-sm md:text-base leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div>

            {/* TITLE */}
            <div className="bg-[#F4F4F4] p-6 w-full max-w-[422px]">
              <h3 className="text-[24px] font-medium text-dark mb-4 border-b-4 border-primary py-4">
                Logistics Services
              </h3>

              {/* LIST */}
              <div className="space-y-5">
                {serviceData.services.map((s, i) => (
                  <div
                    key={i}
                    className="flex justify-between items-center bg-white px-6 py-3 rounded cursor-pointer hover:bg-primary hover:text-white transition group"
                  >
                    <span className="text-lg font-medium text-dark group-hover:text-white">
                      {s.title}
                    </span>

                    <IoChevronForward className="text-lg group-hover:translate-x-1 transition" />
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>

      </section>
    </>
  );
};

export default ServiceDetails;